module.exports = __webpack_public_path__ + "files/b8337b4e83b8719ec9789ef9a1325c64.png";